import { render, staticRenderFns } from "./slot_timer_comp2.vue?vue&type=template&id=49c5053c&scoped=true"
import script from "./slot_timer_comp2.vue?vue&type=script&lang=js"
export * from "./slot_timer_comp2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c5053c",
  null
  
)

export default component.exports